export default __webpack_public_path__ + "c369ae6189733d1d4ca58c79f880f1a9.png";